export default __webpack_public_path__ + "static/classmates-bg-two-82f610c3fa0c1322f0009557d5cf25a7.jpg";